import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DepotFacade } from '@zero/depot/domain';
import { GuidedTourFacade } from '@zero/guided-tour/domain';
import { InvestmentStrategyStore } from '@zero/onboarding/domain';
import { FirstActionStrategyModalComponent } from '@zero/onboarding/feature-investment-strategy/web';
import { ButtonComponent, IconComponent } from '@zero/shared/ui-web-design-system';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { commonRoutes } from 'constants/web-app-constants';
import { combineLatest, filter, map } from 'rxjs';

@Component({
  selector: 'guided-tour',
  imports: [AsyncPipe, TranslocoPipe, IconComponent, ButtonComponent, RouterLink],
  templateUrl: './guided-tour.component.html',
  styleUrl: './guided-tour.component.scss',
  providers: [InvestmentStrategyStore],
})
export class GuidedTourComponent implements OnInit {
  public readonly depotFacade = inject(DepotFacade);
  public readonly investmentStrategyStore = inject(InvestmentStrategyStore);
  public readonly savingsPlanForm = commonRoutes.postlogin.add_savings_plan;
  public readonly savingsPlanHome = commonRoutes.postlogin.savings_plans;
  public readonly orderForm = commonRoutes.postlogin.buyAndSell;
  public readonly deposit = commonRoutes.postlogin.deposit;
  public readonly ETFS_URL = commonRoutes.postlogin.etfs;
  public readonly STOCKS_URL = commonRoutes.postlogin.stocks;

  readonly #guidedTourFacade = inject(GuidedTourFacade);
  readonly #modal = inject(NgbModal);
  readonly #customerStateFacade = inject(CustomerStateFacade);

  public readonly showInstrumentOverviewLinks$ = this.#customerStateFacade.customerBaseData$.pipe(
    filter((cbd) => !!cbd?.customerId),
    map(({ customerId }) => {
      const lastDigit = parseInt(customerId.slice(-1), 10);
      return lastDigit >= 5 && lastDigit <= 9;
    }),
  );

  public readonly shouldDisplayGuidedTour$ = combineLatest([
    this.#guidedTourFacade.showNotification$,
    this.#guidedTourFacade.loading$,
  ]).pipe(filter(([showNotification, loading]) => showNotification && !loading));

  async ngOnInit() {
    await this.investmentStrategyStore.loadStrategies();
    this.investmentStrategyStore.loadNotedStrategy();
  }

  public openFirstActionStrategyModal(): void {
    this.#modal.open(FirstActionStrategyModalComponent, { size: 'md', centered: true });
  }
}
